module.exports = __webpack_public_path__ + "img/business5_E.8cfeffe5.png";